module.exports = __webpack_public_path__ + "img/info.08dd8543.svg";